export default __webpack_public_path__ + "static/media/CSSWiorkflow.852f706f.JPG";